module.exports = __webpack_public_path__ + "static/media/Rotate_Device.d0cfdbb8.png";